export const DISCOUNT = 'DISCOUNT';
export const FINANCE = 'FINANCE';
export const SWEETENER = 'SWEETENER';
export const LAST_IN_HOME_CONSULTATION_AND_PURCHASE_DATE =
  'LAST_IN_HOME_CONSULTATION_AND_PURCHASE_DATE';
export const LAST_INSTALLATION_DATE = 'LAST_INSTALLATION_DATE';
export const EXPIRY_DATE = 'EXPIRY_DATE';
export const AND = 'AND';
export const OR = 'OR';
export const PLUS = 'PLUS';
export const ADD_FINANCE_OFFER = 'Add Finance Offer';
export const REMOVE_FINANCE_OFFER = 'Remove Finance Offer';
export const PROMOTION_TYPES = [
  { label: 'Default', value: 'DEFAULT' },
  { label: 'Special', value: 'SPECIAL' },
];
export const SWEETNER_DISCLAIMER = 'Valid on initial appointment only.';
export const NOTIFY_EMAIL_TEXT = 'Notify Branch';
